const defaultDateFormatterOptions = {
  default: {},
  onlyDate: { year: "numeric", month: "2-digit", day: "2-digit" },
  onlyTime: { hour: "2-digit", minute: "2-digit", second: "2-digit" },
  onlyWeekDay: { weekday: "short" },
  dayAndMonth: { month: "numeric", day: "numeric" },
  dayAndMonthShort: { month: "short", day: "2-digit" },
  monthAndYear: { year: "numeric", month: "numeric" }
};
const defaultRelativeFormatterOptions = {
  long: { style: "long" },
  short: { style: "short" }
};

export { defaultDateFormatterOptions, defaultRelativeFormatterOptions };
